import { useMemo } from 'react';
import useConfig from 'hooks/useConfig';
import { SECTIONS } from 'constant';
import useAuth from './useAuth';
import { ONBOARDING_PATH } from 'config';

function useRouteGuard() {
    let { user, hasOnboarded, isReady, isEligibleForKYC, kycLoaded, hasOnDemand, kycLoadingError } = useAuth();
    let { enabled_sections } = useConfig();

    let enabledPaths = useMemo(() => {
        if (!hasOnboarded) {
            return SECTIONS.Onboarding;
        }
        const enabled = (enabled_sections || []).map((item) => item.key);
        let allowed = Object.keys(SECTIONS.PathToSections).filter((path) => {
            let pathSections = SECTIONS.PathToSections[path] || [];
            return pathSections.some((section) => enabled.includes(section));
        });

        if (hasOnboarded && user?.onboarding?.allow_multiple_onboardings) {
            allowed.push(ONBOARDING_PATH);
        }

        //hide kyc by default - only show when error loading (means eligiblity is not able to retrieve by server load)
        allowed = allowed.filter((s) => s !== '/kyc');
        if (user && isReady && (kycLoaded || kycLoadingError)) {
            //only when there is an error loading the kyc (kycLoadingError), show the kyc section (in section will be shown more details)
            const showKycSection =
                (user?.type === 'customer' && isEligibleForKYC) ||
                user?.kyc_status === 'approved' ||
                (hasOnDemand && (isEligibleForKYC || kycLoadingError));
            if (showKycSection) {
                allowed.push('/kyc');
            }
        }
        return [...SECTIONS.AlwaysAvailable, ...allowed];
    }, [enabled_sections, isReady, hasOnboarded, kycLoaded, isEligibleForKYC, hasOnDemand, kycLoadingError, user]);
    return enabledPaths;
}

export default useRouteGuard;

export const PathIsEnabled = (path: string) => {
    const enabledPaths = useRouteGuard();
    return enabledPaths.indexOf(path) !== -1;
};
